module.exports = __webpack_public_path__ + "static/media/sass.b160d9de.svg";